<template>
  <main><NuxtPage /></main>
</template>
